import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky CTA that starts showing right after the first CTA button
 * scrolls out of view. Shakes on a short loop to keep pulling attention.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const sentinel = document.getElementById('cta-sentinel');
    if (!sentinel) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-forge/40 bg-ink-900/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur transition-[transform,opacity] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-32" data-mp="br2cv18tqn68">
      <a href={CHECKOUT_URL} aria-hidden={!visible} tabIndex={visible ? 0 : -1} className="shake-cta mx-auto flex w-full max-w-xl animate-shake items-center justify-center rounded-lg bg-forge px-4 py-3.5 text-center font-display text-base font-bold uppercase tracking-wide text-white shadow-[0_6px_0_0_#a5330c] transition-colors duration-150 ease-out hover:bg-forge-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-lg" data-id="element-33" data-mp="2b3qj43stkmwj">
        🔥 ACCEDI ORA PER SOLI $27
      </a>
      <p className="mt-1.5 text-center text-[10px] font-semibold tracking-wide text-mute" data-id="element-34" data-mp="1iebd5sg0hk7h">
        Accesso immediato · Garanzia di 7 giorni
      </p>
    </div>;
}